import { expVal } from '@atlassian/jira-feature-experiments';

const jiraSmartRepliesV2RelayProvider = {
	get(): boolean {
		return expVal('jira-smart-replies-v2-main-agg-query-change-sprt', 'isEnabled', false);
	},
};

export default jiraSmartRepliesV2RelayProvider;
